export default __webpack_public_path__ + "static/media/logo-cs-white.d87727ae.svg";